import { Button, ButtonGroup, HStack, Text } from '@chakra-ui/react'
import { QuestionnaireInterface } from '../types/FirestoreUser'

interface QuestionnaireInterfaceToggleProps {
  value: QuestionnaireInterface
  onChange: (value: QuestionnaireInterface) => void
}

export default function QuestionnaireInterfaceToggle({
  value,
  onChange,
}: QuestionnaireInterfaceToggleProps) {
  return (
    <HStack justify='flex-end' spacing={3}>
      <Text fontSize='sm' color='gray.600'>
        Interface
      </Text>
      <ButtonGroup isAttached aria-label='Question interface'>
        <Button
          aria-pressed={value === 'new'}
          colorScheme='purple'
          onClick={() => onChange('new')}
          variant={value === 'new' ? 'solid' : 'outline'}
        >
          New
        </Button>
        <Button
          aria-pressed={value === 'classic'}
          colorScheme='purple'
          onClick={() => onChange('classic')}
          variant={value === 'classic' ? 'solid' : 'outline'}
        >
          Classic
        </Button>
      </ButtonGroup>
    </HStack>
  )
}
